import PropTypes from "prop-types";
import { childrenPropType, titlePropType, classNamePropType } from "../../common";

/**
 * PropTypes for AppPage component
 *
 * @property {React.ReactNode} children - Page content
 * @property {string} [title] - Page title displayed in header
 * @property {string} [className] - Additional CSS classes
 * @property {React.ReactNode} [actions] - Action buttons or elements for page header
 * @property {boolean} [loading] - Show loading state
 */
export const appPagePropTypes = {
  children: childrenPropType,
  title: titlePropType,
  className: classNamePropType,
  actions: PropTypes.node,
  loading: PropTypes.bool,
};
